import React, { useState, useContext } from 'react';
import './home.css';
import { UserContext } from '../context/UserContext';

export default function Communities() {
  const { user } = useContext(UserContext);
  const [openFaq, setOpenFaq] = useState(null);
  const faqs = [
    {
      q: 'Können wir Ihre Tools in unserer Community einsetzen?',
      a: 'Ja. Viele unserer Tools wie Aktivitäts-Bots, Auswertungen, Automationen oder der Lurker lassen sich an Discord-, Twitch- oder Web-Communities anpassen und integrieren.'
    },
    {
      q: 'Unterstützen Sie Moderation und Community-Management?',
      a: 'Auf Wunsch übernehmen wir Moderations-Workflows, erstellen Guidelines und schulen das Team. Außerdem richten wir passende Automationen, Rollen und Bots ein.'
    },
    {
      q: 'Wie flexibel sind die Bots und Integrationen?',
      a: 'Unsere Bots sind modular. Wir passen Funktionen wie Aktivitätstracking, Rollenvergabe, Punkte/Badges, Events, Onboarding oder Schnittstellen (z. B. Twitch, YouTube) an.'
    },
    {
      q: 'Gibt es ein Reporting für Aktivität und Engagement?',
      a: 'Ja. Wir liefern regelmäßige Auswertungen zur Community-Aktivität, Wachstum, Beteiligung und Reichweite – je nach Setup als Dashboard oder Report.'
    },
    {
      q: 'Ist der Einsatz des Lurkers in anderen Communitys möglich?',
      a: 'Ja. Der Lurker kann in Community-Kontexte integriert werden, z. B. für Teilnahme-Checks, Events oder Aktivitäts-Messungen – immer DSGVO-bewusst und zweckgebunden.'
    }
  ];
  return (
    <div className="home-page">
      {/* Hero */}
      <section id="top" className={user ? 'hero-offset-if-sidebar' : ''} style={{ width:'100vw', margin:0, padding:0 }}>
        <h2 className="hero-title" style={{ textAlign: 'center', margin:'0 0 8px' }}>Speziell für Communitys</h2>
        <p className="hero-desc" style={{ margin:'0 auto 24px', textAlign: 'center', maxWidth:760 }}>
          Lösungen, Services und Tools für Communities – von Bots zur Aktivitätsauswertung
          über Automationen bis hin zu Moderations-Workflows, Rollen und Events.
        </p>
      </section>
      {/* Content */}
      <section
        style={{
          width: '100%',
          maxWidth: 1100,
          margin: '0 auto',
          padding: '0 16px 40px 16px',
          color: '#fff',
        }}
      >
        {/* Einleitender Text */}
        <div
          style={{
            maxWidth: 900,
            margin: '0 auto 32px',
            padding: '0 4px',
            fontSize: 16,
            lineHeight: 1.55,
            color: '#D6D9E0'
          }}
          aria-label="Einleitung"
        >
          <p style={{ margin: '0 0 12px' }}>
            Communitys leben von Aktivität, gemeinsamen Zielen und sinnvollen Strukturen. Mit unseren
            Tools, Bots und Workflows unterstützen wir euch dabei, Teilhabe zu fördern, Moderation zu
            erleichtern und Events sichtbar zu machen.
          </p>
          <p style={{ margin: 0 }}>
            Egal ob Discord, Twitch oder die eigene Webplattform – wir verbinden Systeme, automatisieren
            Abläufe und liefern aussagekräftige Auswertungen, damit ihr eure Community gesund entwickeln könnt.
          </p>
        </div>
        {/* Warum Tools & Automationen sinnvoll sind */}
        <div className="highlight-card" style={{ padding: 24, marginBottom: 16 }}>
          <h2 className="highlight-title">Warum Tools & Automationen sinnvoll sind</h2>
          <div style={{ color: '#D4D8DF', fontSize: 15, lineHeight: 1.6 }}>
            <p style={{ margin: '6px 0 14px' }}>
              Je mehr Abläufe automatisiert sind, desto mehr Zeit bleibt für echten Austausch und gute Inhalte.
              Gleichzeitig helfen Auswertungen, die richtigen Entscheidungen zu treffen.
            </p>
            <div style={{ display: 'grid', gap: 2, marginBottom: 14 }}>
              <div style={{ padding: '2px 0' }}>
                <span style={{ fontWeight: 700 }}>Transparenz</span> über Aktivität, Beteiligung und Wachstum
              </div>
              <div style={{ padding: '2px 0' }}>
                <span style={{ fontWeight: 700 }}>Entlastung</span> des Teams durch Automationen
              </div>
              <div style={{ padding: '2px 0' }}>
                <span style={{ fontWeight: 700 }}>Fairness</span> durch nachvollziehbare Rollen und Regeln
              </div>
              <div style={{ padding: '2px 0' }}>
                <span style={{ fontWeight: 700 }}>Motivation</span> durch Badges, Punkte und sichtbare Meilensteine
              </div>
            </div>
            <p style={{ margin: 0 }}>
              Unsere Lösungen sind modular – ihr entscheidet, was ihr braucht. Von einfachen Bots
              bis zu integrierten Web-Workflows mit Dashboards.
            </p>
          </div>
        </div>
        {/* Leistungen für Communitys */}
        <LeistungenCommunity />
        {/* Technik & Integrationen */}
        <div className="highlight-card" style={{ padding: 24, marginBottom: 16 }}>
          <h2 className="highlight-title">Technik & Integrationen</h2>
          <p className="highlight-desc" style={{ marginBottom: 12 }}>
            Unsere Bots und Tools integrieren sich in bestehende Umgebungen – Discord, Twitch, YouTube oder die eigene Website.
          </p>
          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 10, justifyContent: 'center' }}>
            {[
              'Aktivitäts-Bots & Auswertung',
              'Rollen- & Onboarding-Automation',
              'Punkte/Badges-Systeme',
              'Event-Workflows & Teilnehmer',
              'Lurker-Integrationen',
              'Discord/Twitch-Verknüpfungen',
              'Dashboards & Reports',
            ].map((t, i) => (
              <span
                key={i}
                style={{
                  fontSize: 12,
                  lineHeight: '20px',
                  padding: '4px 10px',
                  borderRadius: 999,
                  border: '1px solid rgba(255,255,255,0.15)',
                  background: 'rgba(255,255,255,0.03)',
                  color: '#D4D8DF',
                  textAlign: 'center'
                }}
              >
                {t}
              </span>
            ))}
          </div>
          <p style={{ marginTop: 4, color: '#D4D8DF' }}>
            Auf Wunsch entwickeln wir individuelle Funktionen oder integrieren bestehende Systeme.
          </p>
        </div>
        {/* Prozess */}
        <div className="highlight-card" style={{ padding: 24, marginBottom: 16 }}>
          <h2 className="highlight-title">Unser Prozess – transparent und iterativ</h2>
          <p className="highlight-desc" style={{ margin: '0 0 16px', lineHeight: 1.6 }}>
            Kurze Wege, klare Schritte und regelmäßiges Feedback – damit euer Setup mit euren Zielen mitwächst.
          </p>
          <ol style={{ listStyle: 'none', margin: 0, padding: 0, display: 'grid', gap: 12, gridTemplateColumns: 'repeat(3, 1fr)' }}>
            {[
              'Kick-off & Ziele',
              'Setup & Integrationen',
              'Automationen & Bots',
              'Content & Community-Arbeit',
              'Monitoring & Reporting',
              'Optimierung & Ausbau'
            ].map((step, i) => (
              <li
                key={i}
                style={{
                  display: 'flex',
                  gap: 12,
                  alignItems: 'center',
                  background: 'rgba(255,255,255,0.03)',
                  border: '1px solid rgba(255,255,255,0.12)',
                  borderRadius: 10,
                  padding: '10px 14px',
                  minHeight: 90
                }}
              >
                <span
                  style={{
                    flexShrink: 0,
                    width: 32,
                    height: 32,
                    borderRadius: '50%',
                    background: 'linear-gradient(135deg, #32CD89 0%, #1B774C 100%)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontWeight: 700,
                    fontSize: 14,
                    color: '#fff',
                    boxShadow: '0 0 0 2px rgba(50,205,137,0.4)'
                  }}
                  aria-label={`Schritt ${i + 1}`}
                >
                  {i + 1}
                </span>
                <span style={{ color: '#D4D8DF', fontSize: 14, lineHeight: 1.5, flex: 1, textAlign: 'center' }}>{step}</span>
              </li>
            ))}
          </ol>
        </div>
        {/* FAQ */}
        <div className="highlight-card" style={{ padding: 24, marginBottom: 16 }}>
          <h2 className="highlight-title">Häufige Fragen (FAQ)</h2>
          <div style={{ display: 'grid', gap: 10, width: '100%' }}>
            {faqs.map((item, i) => {
              const open = openFaq === i;
              const panelId = `faq-panel-comm-${i}`;
              return (
                <div
                  key={i}
                  style={{
                    border: '1px solid rgba(255,255,255,0.12)',
                    borderRadius: 10,
                    background: 'rgba(255,255,255,0.03)',
                    width: '100%'
                  }}
                >
                  <button
                    onClick={() => setOpenFaq(open ? null : i)}
                    aria-expanded={open}
                    aria-controls={panelId}
                    style={{
                      width: '100%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      position: 'relative',
                      background: 'transparent',
                      color: '#E2E5EA',
                      fontWeight: 600,
                      padding: '12px 14px',
                      paddingRight: 38,
                      border: 'none',
                      textAlign: 'center',
                      cursor: 'pointer'
                    }}
                  >
                    <span style={{ display: 'block', width: '100%', textAlign: 'center' }}>{item.q}</span>
                    <span aria-hidden="true" style={{ opacity: 0.85, position: 'absolute', right: 12, top: '50%', transform: 'translateY(-50%)' }}>
                      {open ? '−' : '+'}
                    </span>
                  </button>
                  {open && (
                    <div id={panelId} style={{ padding: '0 14px 12px 14px', color: '#D4D8DF', lineHeight: 1.6 }}>
                      <p style={{ margin: 0 }}>{item.a}</p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
        {/* Verweise & Kontakt */}
        <div className="highlight-card" style={{ padding: 24 }}>
          <h2 className="highlight-title">Mehr erfahren &amp; Kontakt</h2>
          <p className="highlight-desc" style={{ marginBottom: 12 }}>
            Ihr möchtet prüfen, welche Module für eure Community sinnvoll sind? Wir zeigen euch passende Setups
            und erstellen auf Wunsch ein Pilotprojekt.
          </p>
          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
            <a
              className="hero-btn-secondary"
              href="/leistungen-im-detail"
              style={{ padding: '12px 18px', textDecoration: 'none' }}
            >
              Leistungen im Detail
            </a>
            <a
              className="hero-btn-primary"
              href="/kontakt"
              style={{ padding: '12px 18px', textDecoration: 'none' }}
            >
              Kontakt aufnehmen
            </a>
          </div>
          <div style={{ marginTop: 16 }}>
            <a href="#top" style={{ color: '#32CD89' }}>
              Nach oben
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}

function LeistungenCommunity() {
  const sections = [
    {
      key: 'bots',
      title: 'Bots & Automationen',
      bodyLines: {
        intro: 'Wir richten modulare Bots ein und passen sie an eure Community an.',
        heading: 'Mögliche Module:',
        items: [
          'Aktivitäts-Tracking & Auswertung',
          'Rollen- und Onboarding-Automation',
          'Punkte, Badges & Meilensteine',
          'Event-Reminder & Teilnahme-Workflows',
          'Moderations-Tools & Escalation-Flows'
        ],
        outro: 'Alles DSGVO-bewusst und transparent – mit klaren Opt-ins.'
      }
    },
    {
      key: 'lurker',
      title: 'Lurker-Integrationen',
      bodyLines: {
        intro: 'Wir integrieren den Lurker kontextbezogen – etwa für Events oder Aktivitätsmessungen.',
        heading: null,
        items: [
          'Individuelle Konfiguration & Regeln',
          'Datenschutzkonforme Nutzung',
          'Kombination mit Punkten/Badges',
          'Auswertung & Reporting'
        ],
        outro: 'So macht ihr Teilnahme sichtbar und motiviert zur Interaktion.'
      }
    },
    {
      key: 'community',
      title: 'Community-Management',
      bodyLines: {
        intro: 'Wir unterstützen Moderation, Guidelines und Team-Workflows – auf Wunsch inkl. Schulungen.',
        heading: null,
        items: [
          'Moderations-Guides & Rollen',
          'Onboarding-Prozesse',
          'Konflikt- und Eskalationspfade',
          'Community-Aktionen & Challenges'
        ],
        outro: 'Starke Strukturen schaffen Sicherheit und fördern Beteiligung.'
      }
    },
    {
      key: 'content',
      title: 'Content & Events',
      bodyLines: {
        intro: 'Wir planen Community-Events, erstellen Content-Formate und begleiten Highlights.',
        heading: null,
        items: [
          'Event-Planung & Promotion',
          'Highlight-Clips & Recaps',
          'Livestream-Begleitung',
          'Formatentwicklung (Serien, Challenges)'
        ],
        outro: 'So bleiben Aktionen sichtbar – vor, während und nach dem Event.'
      }
    },
    {
      key: 'web',
      title: 'Web & Dashboards',
      bodyLines: {
        intro: 'Wir verbinden Bots und Web zu einer stimmigen Plattform.',
        heading: null,
        items: [
          'Mitgliederbereiche & Rollen',
          'Formulare & Workflows',
          'Dashboards & Berichte',
          'Integrationen (Discord/Twitch/YouTube)'
        ],
        outro: 'Alles modular und erweiterbar – passend zu eurer Community.'
      }
    }
  ];
  const TILE_HEIGHT = 380;
  return (
    <div className="highlight-card" style={{ padding: 24, marginBottom: 16 }}>
      <h2 className="highlight-title" style={{ marginBottom: 12 }}>Unsere Leistungen für Communitys</h2>
      <p style={{ color: '#D4D8DF', margin: '0 0 18px', fontSize: 15, lineHeight: 1.5 }}>
        Wir kombinieren Bots, Workflows und Content, damit eure Community wächst und gesund bleibt.
      </p>
      <div style={{
        display: 'grid',
        gap: 16,
        gridTemplateColumns: 'repeat(3, 1fr)',
        alignItems: 'stretch'
      }}>
        {sections.map(sec => (
          <div
            key={sec.key}
            style={{
              border: '1px solid rgba(255,255,255,0.15)',
              background: 'rgba(50,205,137,0.12)',
              borderRadius: 14,
              padding: '14px 16px',
              boxShadow: '0 0 0 1px rgba(50,205,137,0.35), 0 4px 14px -2px rgba(0,0,0,0.4)',
              display: 'flex',
              flexDirection: 'column',
              height: TILE_HEIGHT,
              overflow: 'hidden'
            }}
          >
            <div style={{ fontWeight: 700, fontSize: 15, marginBottom: 10 }}>{sec.title}</div>
            <div style={{ fontSize: 13, lineHeight: 1.55, color: '#D4D8DF', overflow: 'hidden' }}>
              {sec.body && sec.body}
              {sec.bodyLines && (
                <div>
                  <p style={{ margin: '0 0 8px' }}>{sec.bodyLines.intro}</p>
                  {sec.bodyLines.heading && (
                    <p style={{ margin: '0 0 6px', fontWeight: 600, color: '#E2E5EA' }}>{sec.bodyLines.heading}</p>
                  )}
                  <div style={{ display: 'grid', gap: 4, marginBottom: 10 }}>
                    {sec.bodyLines.items.map((it, i) => (
                      <div key={i} style={{ padding: '2px 0' }}>{it}</div>
                    ))}
                  </div>
                  <p style={{ margin: 0 }}>{sec.bodyLines.outro}</p>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
